export default {
    getCustomerAccount: '/mediafax_new/param_page', //客户账号/主页
    getCustomerName: '/customer/param_name',
    getOperateAccount: '/mediafax/account/param_account', //运营账号
    getDict: '/dictionary/dictionaryList/'
}
